export const SHOPIFY_BUY_SDK_URL = process.env.NEXT_PUBLIC_SHOPIFY_SDK_URL ?? 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js'
